import { Navigate } from "react-router-dom";
import TransactionOutlet from "./transaction-outlet";
import { Transactions } from "./page/Transactions";
import { Payouts } from "./page/Payouts";

const TransactionRoutes = [
  {
    path: "/transactions",
    element: <TransactionOutlet />,
    children: [
      {
        index: true,
        element: <Navigate to="collections" replace />,
      },
      {
        path: "collections",
        element: <Transactions />,
      },
      {
        path: "payouts",
        element: <Payouts />,
      },
    ],
  },
];

export default TransactionRoutes;
